/**
 * Versión de la aplicación - www.peoplefortech.com
 * Se incrementa automáticamente en cada deploy (npm run deploy)
 */
export const APP_VERSION = '0.1.18';
